import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./plugins/NProgress";
import './assets/style/style.css'
import './plugins/element.js'
import cookie from './plugins/cookie'
import { getUserInfo } from './utils/auth'

router.beforeEach((to, from, next) => {
  if (!getUserInfo() && to.name !== 'login') {
    next({ path: '/login' })
  } else {
    next()
  }
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  cookie,
  render: h => h(App)
}).$mount('#app')
